<template lang="pug">
    .contactpage
        .section(v-if="sections.length" v-for="(section, index) in sections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            ImageSection(v-else-if="section.key === 'image'" :section="section")
            Post(v-else-if="section.key === 'post'" :section="section")
            Slider(v-else-if="section.key === 'slider'" :section="section")
            Contact.column.is-4(v-else-if="section.key === 'contact'" :section="section")
            Evaluation(v-else-if="section.key === 'evaluation'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import ImageSection from '@/components/ImageSection'
import Post from '@/components/Post'
import Slider from '@/components/Slider'
import Contact from '@/components/Contact'
import Evaluation from '@/components/Evaluation/index.vue'

export default {
    name: 'EvaluationPage',
    components: {
        Heading,
        ImageSection,
        Post,
        Slider,
        Contact,
        Evaluation
    },
    computed: {
        ...mapGetters({
            sections: 'currentPage/sections',
        })
    }
}

</script>

<style lang="sass" scoped>
    .contactpage
        & > .section
            padding-bottom: 0
            &:first-child
                padding-top: 4.5rem
            &:last-child
                padding-bottom: 4.5rem
            &.category-page-teaser
                display: none
        .section.slider,
        .section.banners
            padding: 0
        .section.heading
            text-transform: initial
</style>
